import {
    FETCH_MUSCLE_MAPPING_MODEL_FETCHING,
    FETCH_MUSCLE_MAPPING_MODEL_SUCCESS,
    FETCH_MUSCLE_MAPPING_MODEL_FAIL
} from 'actions/ActionTypes';

const initialState = {
    muscleMappingModel: undefined,
    muscleMappingModelFetching: false,
    muscleMappingModelSuccess: false,
    muscleMappingModelFail: false
};

const muscleMappingModelFetching = (state) => ({
    ...state,
    muscleMappingModelFetching: true
});

const muscleMappingModelFetchFinished = (isSuccess) => (state, action) => ({
    ...state,
    muscleMappingModel: isSuccess ? action.muscleMappingModel : {},
    muscleMappingModelFetching: false,
    muscleMappingModelSuccess: isSuccess,
    muscleMappingModelFail: !isSuccess
});

export const isMuscleMappingModelFetching = (state) => state.muscleMappingModel.muscleMappingModelFetching;

export const isMuscleMappingModelSuccess = (state) => state.muscleMappingModel.muscleMappingModelSuccess;

export const isMuscleMappingModelFail = (state) => state.muscleMappingModel.muscleMappingModelFail;

export const getMuscleMappingModel = (state) => state.muscleMappingModel.muscleMappingModel;

const handlers = {
    [FETCH_MUSCLE_MAPPING_MODEL_FETCHING]: muscleMappingModelFetching,
    [FETCH_MUSCLE_MAPPING_MODEL_SUCCESS]: muscleMappingModelFetchFinished(true),
    [FETCH_MUSCLE_MAPPING_MODEL_FAIL]: muscleMappingModelFetchFinished(false)
};

export default function muscleMappingModel(state = initialState, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}
